import { mapApiImageToImageProps } from './common.mappers';

import type { FCitiesTemplateProps } from '@/components/templates/FCitiesTemplate.vue';

export function mapApiDataToCities(
  citiesRawData: StrapiResponseData<AudiencePageContentType> | undefined
): FCitiesTemplateProps {
  const guideDataAttributes =
    citiesRawData?.attributes?.featured_guide?.data?.attributes;
  return {
    featuredGuide: {
      title: guideDataAttributes?.title || '',
      buttonLocation: `/resources/guides/${guideDataAttributes?.slug ?? ''}`,
    },
    blogPostCards: (
      citiesRawData?.attributes.explore_section?.blog_posts?.data ?? []
    ).map(card => ({
      text: card.attributes?.title ?? '',
      image: mapApiImageToImageProps(
        card.attributes?.main_image?.data?.attributes,
        'medium'
      ),
      link: { location: `/resources/blog/${card.attributes?.slug}` },
      linkText: '',
    })),
  };
}
